import React from 'react';
import ReactDOM from 'react-dom/client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import './index.css';
import App from './App';
import MaintenanceOverlay from './components/MaintenanceOverlay';
import { GOOGLE_CLIENT_ID } from './config';

const Root = (
  <>
    <App />
    <MaintenanceOverlay />
  </>
);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  GOOGLE_CLIENT_ID
    ? <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>{Root}</GoogleOAuthProvider>
    : Root
);
